/*
 * @Author: wsx
 * @Date: 2022-01-15 16:39:06
 * @LastEditTime: 2022-01-23 14:58:05
 * @LastEditors: your name
 * @Description:
 */
export default [{
    path: "preventionPersonManage",
    name: "preventionPersonManage",
    component: () =>
      import ("@/views/prevention/preventionPersonManage.vue"),
    meta: {
      title: "巡防员管理"
    }
  },
  {
    path: "clewManage",
    name: "clewManage",
    component: () =>
      import ("@/views/prevention/clewManage.vue"),
    meta: {
      title: "线索管理"
    }
  },
  {
    path: "preventionTask",
    name: "preventionTask",
    component: () =>
      import ("@/views/prevention/preventionTask/index.vue"),
    meta: {
      title: "巡防任务"
    }
  },
  {
    path: "preventionTaskList",
    name: "preventionTaskList",
    component: () =>
      import ("@/views/prevention/preventionTaskList.vue"),
    meta: {
      title: "任务列表"
    }
  },
  {
    path: "preventionMap",
    name: "preventionMap",
    component: () =>
      import ("@/views/prevention/preventionMap"),
    meta: {
      title: "巡防地图"
    }
  },

];